import { __extends } from "tslib";
import * as React from "react";
import { BackHandler, AppState } from 'react-native';
var ContentView = /** @class */ (function (_super) {
    __extends(ContentView, _super);
    /* CONSTRUCTOR */
    function ContentView(props) {
        var _this = _super.call(this, props) || this;
        // HOT RELOAD FIX
        _this.render = _this.render.bind(_this);
        return _this;
    }
    /* COMPONENT EVENTS */
    ContentView.prototype.componentDidMount = function () {
        if (this._binding != null) {
            if (this.props.backhandler != undefined && this.props.backhandler == true) {
                BackHandler.addEventListener("hardwareBackPress", this._binding.OnBackAndroidPressed);
            }
            AppState.addEventListener('change', this._binding.onBackground);
            this._binding.isMounted = true;
            this._binding.componentDidMount();
        }
    };
    ContentView.prototype.componentWillUnmount = function () {
        if (this._binding != null) {
            if (this.props.backhandler != undefined && this.props.backhandler == true) {
                BackHandler.removeEventListener("hardwareBackPress", this._binding.OnBackAndroidPressed);
            }
            AppState.removeEventListener('change', this._binding.onBackground);
            this._binding.isMounted = false;
            this._binding.componentWillUnmount();
        }
    };
    ContentView.prototype.componentDidUpdate = function () {
        if (this._binding != null) {
            this._binding.componentDidUpdate();
        }
    };
    ContentView.prototype.setBackHandler = function (handler) {
        BackHandler.removeEventListener("hardwareBackPress", this._binding.OnBackAndroidPressed);
        BackHandler.addEventListener("hardwareBackPress", handler);
    };
    ContentView.prototype.removeBackHandler = function (handler) {
        BackHandler.removeEventListener("hardwareBackPress", handler);
    };
    ContentView.prototype.shouldComponentUpdate = function () {
        if (this._binding != null) {
            return this._binding.shouldComponentUpdate();
        }
        return false;
    };
    /* METHODS */
    // Used to set the bindingContext of the view
    ContentView.prototype.bind = function (viewModel, style) {
        this._binding = viewModel;
        this.binding = this._binding;
        this.style = style;
    };
    return ContentView;
}(React.Component));
export default ContentView;
